







































































import Enumerable from "linq";
import { Mixins, Component, Prop } from "vue-property-decorator";
import { EditorItemMixin } from "./mixins";
import { ReceptionRecipient } from "../../../../domain/workflow/reception";
import { ReceptionTypeItem } from "../../../../domain/workflow/items";
import { ModelEditableMixin } from "../../../system/mixins";

import ComboBoxSelector from "../../../system/selectors/ComboBoxSelector.vue";
import DatePicker from "../../../system/selectors/DatePicker.vue";
import TimePicker from "../../../system/selectors/TimePicker.vue";

@Component({
  components: {
    DatePicker,
    TimePicker,
    ComboBoxSelector
  }
})
export default class ReceptionRecipientEditor extends Mixins(
  EditorItemMixin,
  ModelEditableMixin
) {
  // ModelEditableMixinに実体あり
  editingSource: ReceptionRecipient;

  @Prop()
  relationshipItems: ReceptionTypeItem[];

  @Prop()
  paymentStatusItems: ReceptionTypeItem[];

  data(): any {
    return {
      relationships: [],
      initialPaymentStatus: null,
    };
  }
  // 選択肢設定が変更された場合を考慮して算出プロパティにしない
  // this.relationshipが"選択肢にない項目"を選択している状態(依頼登録後に設定変更した場合に起こる)のときに
  // 編集でthis.relationshipを"選択肢にある項目"に変更したとき、元の"選択肢にない項目"に戻せなくなるため
  relationships: string[];

  initialPaymentStatus: number;

  mounted(): void {
    this.relationships = this.toRelationships(this.relationshipItems);
    this.initialPaymentStatus = this.receptionPaymentStatus;
  }

  get receiptDate(): Date {
    if (!this.editingSource.receiptDate) {
      return null;
    }
    // TODO:implement date format
    return this.editingSource.receiptDate;
  }

  set receiptDate(value: Date) {
    this.writeProperty((r: ReceptionRecipient) => (r.receiptDate = value));
  }

  get receiptTime(): Date {
    if (!this.editingSource.receiptTime) {
      return null;
    }
    return this.editingSource.receiptTime;
  }

  set receiptTime(value: Date) {
    this.writeProperty((r: ReceptionRecipient) => (r.receiptTime = value));
  }

  get name(): string {
    return this.editingSource.name;
  }

  set name(value: string) {
    this.writeProperty((c: ReceptionRecipient) => (c.name = value));
  }

  get relationship(): string {
    return this.editingSource.relationship;
  }

  set relationship(value: string) {
    this.writeProperty((c: ReceptionRecipient) => (c.relationship = value));
  }

  get receiptMoney(): string {
    return this.editingSource.receiptMoney;
  }

  set receiptMoney(value: string) {
    this.writeProperty((c: ReceptionRecipient) => (c.receiptMoney = value));
  }

  get receptionPaymentStatus(): number {
    return this.editingSource.paymentStatus;
  }

  set receptionPaymentStatus(value: number) {
    this.writeProperty((c: ReceptionRecipient) => c.paymentStatus = value);
  }

  get note(): string {
    return this.editingSource.note;
  }

  set note(value: string) {
    this.writeProperty((c: ReceptionRecipient) => (c.note = value));
  }

  toRelationships(items: ReceptionTypeItem[]): string[] {
    // isDisable=false もしくは編集時に選択されている続柄を表示
    return Enumerable.from(items)
      .where(r => !r.isDisable || (this.relationship && r.name === this.relationship))
      .select(r => r.name)
      .toArray();
  }

  isPaymentStatusEnable(paymentStatus: ReceptionTypeItem): boolean {
    // isDisable=false もしく起動時の交付方法を表示
    return !paymentStatus.isDisable || (this.initialPaymentStatus === paymentStatus.id);
  }
}
